import type { SpecificationLangDetectResult, SpecificationTaskCreatePayload } from '../types/specification-task-create';

export const SpecificationTaskCreateRepository = Symbol.for('SpecificationTaskCreateRepository');

export interface SpecificationTaskCreateRepository {
    /** 获取历史用户输入信息 */
    getHistoryInput(taskId: string): Promise<Partial<SpecificationTaskCreatePayload>>;

    /** 输入内容, 进行语言检测 */
    langDetect(payload: SpecificationTaskCreatePayload): Promise<SpecificationLangDetectResult>;

    /** 创建任务 */
    createTask(taskId: string, payload: SpecificationTaskCreatePayload): Promise<void>;
}
